import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import Component from './components/AnchorNodeView';

import s from '../../components/Editor/styles/base.scss';

export interface AnchorOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    anchor: {
      /**
       * Add a hard break
       */
      setAnchor: (id: string) => ReturnType;
    };
  }
}

/**
 * Anchor extension
 *
 * Node extension that adds named anchors to the editor, in the editor we insert a + image of
 * anchor so the user can see them and delete them. Then in the viewer we render just the anchor.
 */
export const Anchor = Node.create<AnchorOptions>({
  name: 'anchor',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      id: {
        default: null,
      },
    };
  },

  inline: true,
  group: 'inline',
  draggable: true,

  parseHTML() {
    return [{ tag: 'a[id]:not([href])' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'a',
      mergeAttributes(this.options.HTMLAttributes, {
        ...HTMLAttributes,
        contenteditable: false,
        class: s['anchor'],
        title: `Anchor ID: ${HTMLAttributes.id}`,
        'data-anchor': '1',
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Component as any);
  },

  renderText() {
    return '';
  },

  addCommands() {
    return {
      setAnchor:
        id =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { id },
          });
        },
    };
  },
});
